var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Button',{attrs:{"href":_vm.block.attributes.url,"value":_vm.block.attributes.text,"name":_vm.block.attributes.text}})
}
var staticRenderFns = []

export { render, staticRenderFns }